import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'suite-marketplaces',
  templateUrl: './marketplaces.component.html',
  styleUrls: ['./marketplaces.component.scss']
})
export class MarketplacesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
